import PropTypes from 'prop-types';
import { Component } from 'react';
import { NumericFormat } from 'react-number-format';
import { connect } from 'react-redux';
import { getCurrencyFormatProps } from '../../utils/NumberUtilsValores';
import CustomTextField from './../CustomTextField/CustomTextField';

class CustomCurrencyField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      internalValue: null,
    };
  }

  getCustomInput = (customInputProps) => {
    const customProps = {
      ...this.props,
      ...customInputProps,
    };
    delete customProps.dispatch;
    return <CustomTextField {...customProps} />;
  };

  getProcessedValueForDisplay = (value) => {
    if (typeof value === 'string') {
      return value.replace('R$', '').trim();
    }
    return value;
  };

  handleValueChange = (values) => {
    const { formattedValue } = values;
    const cleanedValue = this.getProcessedValueForDisplay(formattedValue);
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(cleanedValue);
    }
  };

  render() {
    const { languageValues } = this.props;
    const displayValue = `R$ ${this.getProcessedValueForDisplay(
      this.props.value
    )}`;

    return (
      <NumericFormat
        {...getCurrencyFormatProps(languageValues)}
        value={displayValue}
        customInput={this.getCustomInput}
        onValueChange={this.handleValueChange}
      />
    );
  }
}

CustomCurrencyField.propTypes = {
  ...CustomTextField.propTypes,
  allowEmpty: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

export default connect(mapStateToProps)(CustomCurrencyField);
